import {  get } from "../../service/api";

const GetMerchantInvoices = async (merchantId,queryString) => {
    try {
        const response = await get(`/invoice?merchantId=${merchantId}&${queryString}`);
        return response;
    } catch (error) {
        console.error('Error GetMerchantInvoices:', error);
        throw error;
    }
};

export default GetMerchantInvoices;